import bgu from '../../utilities/customers/bgu.png';
import bs from '../../utilities/customers/bs.png';
import ank from '../../utilities/customers/ank.png';
import lola from '../../utilities/customers/lola.png';
import nf from '../../utilities/customers/nf.png';
import mar from '../../utilities/customers/mar.png';
import by from '../../utilities/customers/by.png';
import ink from '../../utilities/customers/ink.png';
import tech from '../../utilities/customers/tech.png';
import mek from '../../utilities/customers/mek.png';
import eb from '../../utilities/customers/eb.png';
import muk from '../../utilities/customers/muk.png';
import sal from '../../utilities/customers/sal.png';
import oten from '../../utilities/customers/oten.png';
import dsay from '../../utilities/customers/tech.png';
import nbn from '../../utilities/customers/nbn.png';
import bsm from '../../utilities/customers/bsm.png';
import sce from '../../utilities/customers/sce.png';
import tad from '../../utilities/customers/tad.png';
import ya from '../../utilities/customers/ya.png';
//////////CUSTOMERSLIDER//////////////////
export const customersList= [
    bgu,
    bs,
    ank,
    lola,
    nf,
    mar,
    by,
 sce,
    tech,
    mek,
    eb,
    muk,
    sal,
    oten,
    dsay,
    nbn,
    bsm,
    ink, 
    tad,
    ya
    ];